import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Flex,
  Pagination,
  Result,
  Row,
  Select,
  Skeleton,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useAddressHelper } from "utils/useAddressHelper";
import { useGetJobs } from "api/jobs/useGetJobs";
import { JobInterface } from "api/jobs/dto";
import SaveIcon from "../../assets/save.svg";
import CompanyIcon from "../../assets/rectangle.svg";
import { calculateDaysAgo, formatDate } from "utils/date";
import { JobTypeValues } from "enum/job-type";
import { useNavigate /*useParams*/ } from "react-router-dom";
import { storage } from "utils/storage";
import {
  QueryParamsStatus,
  useFilterPagination,
} from "hooks/useFilterPagination";
import { useIsMobile } from "hooks/useIsMobile";

const { Option } = Select;
const { Text } = Typography;

const Hero = () => {
  const { getProvinceOptions, getDistrictOptions, address, setAddress } =
    useAddressHelper();

  const navigate = useNavigate();


  const isMobile = useIsMobile();

  const user = storage.getUserFromStorage();

  const { queryParamaters, onFilterChange, onTableChange } =
    useFilterPagination();

  const { data, isError, isPending, isSuccess } = useGetJobs(queryParamaters);

  const handleFilter = () => {
    document
      .querySelector("#data-wrapper")
      ?.scrollIntoView({ behavior: "smooth" });
  };
  const renderJobsContent = () => {
    if (isError) {
      return (
        <Result
          status="error"
          title="Server Error"
          subTitle="There seems to be problem with the server. Please check after few minutes."
        ></Result>
      );
    }

    if (isPending) {
      return (
        <Card style={{ width: "100%", marginTop: 16, height: "700px" }}>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </Card>
      );
    }

    if (data?.data?.length === 0) {
      return (
        <Card
          style={{
            height: "180px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Empty />
        </Card>
      );
    }

    if (isSuccess && data?.data?.length > 0) {
      return (
        <>
          <Row gutter={[32, 32]}>
            {data?.data?.map((i: JobInterface) => (
              <Col key={i.id} xs={24} sm={24} md={24} lg={12} xl={12}>
                <Card hoverable>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                    }}
                  >
                    <h3 className="text-2xl md:text-2xl font-medium  text-black  mb-2">
                      {i?.jobTitle}
                    </h3>
                    <img alt="#" src={SaveIcon} />
                  </div>

                  <Flex gap={"middle"} style={{ margin: "14px 0px" }}>
                    <Avatar src={CompanyIcon} size={60} />
                    <Flex vertical flex={1}>
                      <Flex justify="space-between">
                        <h3 className="text-lg md:text-lg font-semibold  text-black">
                          {i?.companyName}
                        </h3>
                        <div>{calculateDaysAgo(i?.createdAt.toDate())} days ago</div>
                      </Flex>
                      <Text type="secondary">
                        {/* {formatLocation(i?.location)} */}
                      </Text>
                    </Flex>
                  </Flex>
                  <div className="flex flex-col md:flex-row md:justify-between gap-y-5 px-2 py-2 ml-2">
                    <Text className="font-medium text-gray-700">{i?.jobType}</Text>
                    <Text className="text-sm text-gray-500">Deadline: {formatDate(i?.deadlineAt.toDate())}</Text>
                  </div>

                  <div className="flex flex-col md:flex-row md:justify-between gap-y-4">
                    {i?.salary?.isPubliclyAvailable ? (
                      <div className="btn-sm text-neutral-500 bg-slate-50 px-2 py-2 rounded-full">
                        Estimated Salary  {i?.salary?.amount}
                      </div>
                    ) : (
                      <p></p>
                    )}
                    <button
                      onClick={() => {
                        if (!user) {
                          navigate(`/login?roleType=Enumerator`);
                        } else {
                          navigate(`/enumerator/job/details/${i.id}`);
                        }
                      }}
                      className="btn-sm text-white bg-primary hover:bg-primary ml-3 px-5 py-2 rounded w-28 "
                    >
                      View more
                    </button>
                  </div>

                  {/* <div className="mt-4">
                    {i?.skills?.map((s, index) => (
                      <Tag key={s + index} color={getColorOption()}>{s}</Tag>
                    ))}
                  </div> */}
                </Card>
              </Col>
            ))}
          </Row>
        </>
      );
    }
  };

  return (
    <>
      <section
        className="relative"
        style={{
          backgroundColor: "#EDF6F1",
          height: "100vh",
        }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 ">
          <div className="pt-16 pb-0 md:pt-40 md:pb-20 ">
            <div className="text-center pb-6 md:pb-16 ">
              {/* Changed text to "Find Perfect Enumerator jobs!" */}
              <h1
                className="text-3xl md:text-6xl font-extrabold mb-4"
                data-aos="zoom-y-out"
              >
                Find the Perfect Enumerator Jobs or
              </h1>
              <h1
                className="text-3xl md:text-6xl font-extrabold mb-4"
                data-aos="zoom-y-out"
              >
                {/* Changed text to "We Will Help You Find One!" */}
                <span className="bg-clip-text text-green-600 ml-4">
                  Hire Top Talent—All in One Place!
                </span>
              </h1>
              {/* <h1 className="text-4xl md:text-6xl font-extrabold  mb-4" data-aos="zoom-y-out">
                You Deserve
              </h1> */}
              <div className="max-w-3xl mx-auto">
                <p
                  className="md:text-xl mb-8"
                  data-aos="zoom-y-out"
                  data-aos-delay="150"
                  style={{ color: "#637381" }}
                >
                  HireEnumerators.com connects skilled enumerators with recruiters who need them for research, surveys, and data collection. Ready to get started?

                </p>
              </div>
              <div className="md:mt-12 ">
                <Card
                  style={{ boxShadow: "0px 5px 12px 0px #2391511F" }}
                  className="__hero__card "
                >
                  <Row gutter={[24, 12]} className="flex justify-around">
                    <Col
                      xs={24}
                      sm={24}
                      md={
                        6
                      }
                      lg={
                        6
                      }
                      xl={
                        6
                      }
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Select
                        allowClear
                        placeholder="Select Province"
                        className={`w-full border-none ${isMobile ? "__job__type" : "__hero__dropdown"}`}

                        options={getProvinceOptions()}
                        onChange={(value) => {
                          onFilterChange(
                            value,
                            QueryParamsStatus.FIND_BY_PROVINCE,
                          );
                          setAddress({ ...address, province: value });
                        }}
                      />
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={
                        6
                      } /* Adding the width size of the District . IF needed unCommentIt*/
                      lg={
                        6
                      } /* Adding the width size of the District . IF needed unCommentIt*/
                      xl={
                        6
                      } /* Adding the width size of the District . IF needed unCommentIt*/
                     
                      className="flex justify-center items-center"
                    >
                      <Select
                        allowClear  
                        placeholder="Select District"
                        
                        className={`w-full border-none ${isMobile ? "__job__type" : "__hero__dropdown"}`}
                        optionFilterProp="children"
                        filterOption={(input, option: any) => {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          );
                        }}
                        onChange={(value) => {
                          onFilterChange(
                            value,
                            QueryParamsStatus.FIND_BY_DISTRICT,
                          );
                          setAddress({ ...address, district: value });
                        }}
                      >
                        {getDistrictOptions()?.map((district) => (
                          <Option key={district?.label} value={district?.label}>
                            {district?.label}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={4}
                      lg={4}
                      xl={4}
                      className="flex justify-content-end "
                    >
                      <Button
                        className="md:h-12 h-10 px-8 w-full border-2 border-border text-base  flex justify-center items-center gap-2 bg-primary text-white border-none "
                        icon={<SearchOutlined />}
                        type="primary"
                        onClick={handleFilter}
                      >
                        Search
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section >
      <div className="max-w-6xl mx-auto px-4 sm:px-6  md:pt-0 pt-10" id="data-wrapper">
        <div className="flex items-center justify-center mt-16">
          <h1
            className="text-4xl md:text-6xl font-extrabold leading-tighter tracking-tighter mb-4"
            data-aos="zoom-y-out"
          >
            Latest Popular
            <span className="bg-clip-text text-green-600 ml-4">Job</span>
          </h1>
        </div>
        <div className="mt-8">
          <Row className="mb-8">
            <Select
              value={queryParamaters?.findByJobType}
              allowClear
              placeholder="Sort by Job Type"
              className="__job__type"
              options={[
                { value: JobTypeValues.FULL_TIME, label: "Full Time" },
                { value: JobTypeValues.PART_TIME, label: "Part Time" },
                { value: JobTypeValues.CONTRACT, label: "Contract" },
                { value: JobTypeValues.INTERNSHIP, label: "Internship" },
              ]}
              onChange={(value) =>
                onFilterChange(value, QueryParamsStatus.FIND_BY_JOB_TYPE)
              }
            />
          </Row>
          {renderJobsContent()}
        </div>

        <div className="flex items-center justify-center mt-16">
          <div className="mt-6 mb-12 pb-10">
            {data?.totalData && data.totalData > 10 && (
              <Pagination
                current={data?.page}
                total={data?.totalData}
                onChange={onTableChange}
                defaultCurrent={1}
                defaultPageSize={20}
                pageSizeOptions={undefined}
                showSizeChanger={false}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;